import useSWR from "swr";
import * as http from "@/utils/request";
import { RFResponseCommon } from "@/interfaces/common";
import { RegionModel } from "@/interfaces/loginTypes";

const BASE_URL = process.env.NEXT_PUBLIC_BASE_API;

export const useCountryCode = (lang: string) => {
  const url = `${BASE_URL}/geolocation/api/countries?smsAvailable=true&sticky=false&language=${lang}`;
  const {
    data = [],
    error,
    isValidating,
  } = useSWR(
    url,
    async (url) =>
      await http
        .get<RFResponseCommon<RegionModel[]>>(url)
        .then((res) => res.data)
  );

  return {
    data,
    error,
  };
};
